import { Reducer } from 'redux';
import { SystemUserManagementAction, SystemUserManagementActionTypes } from './systemUserManagementActions';

export interface SystemUserManagementState {
    selectedSystemUserGroupId: string;
    selectedSystemUserGroupName: string;
    selectedSystemAnnouncementId: string;
}

export const defaultState: SystemUserManagementState = {
    selectedSystemUserGroupId: '',
    selectedSystemUserGroupName: '',
    selectedSystemAnnouncementId: '',
};

export const systemUserManagementReducer: Reducer<SystemUserManagementState, SystemUserManagementAction> = (
    state = defaultState,
    action: SystemUserManagementAction
) => {
    switch (action.type) {
        case SystemUserManagementActionTypes.SYSTEM_USER_GROUP_SELECTION: {
            return {
                ...state,
                selectedSystemUserGroupId: action.payload.systemUserGroupId,
                selectedSystemUserGroupName: action.payload.systemUserGroupName,
            };
        }
        case SystemUserManagementActionTypes.SYSTEM_ANNOUNCEMENT_SELECTION: {
            return {
                ...state,
                selectedSystemAnnouncementId: action.payload.systemAnnouncementId,
            };
        }
        default: {
            return state;
        }
    }
};
